export const onUpdatePipeline = `
    subscription onUpdatePipeline {
        onUpdatePipeline {
            id
            name
            description
            pipelineType
            pipelineStatus
            templateId
            codeRepositoryName
            branchName
            originalStackName
            stackName
            buildCommand
            deploymentAccountGroupId
            stages {
              name
              order
              buildProvider
              deployProvider
              requiresApproval
              stageKind
            }
            deploymentAccounts {
              accountId
              accountName
              region
              deploymentBucketName
            }
            createdByUsername
            managedByUsername
            created
            updated
        }
    }
`;
